import { render, staticRenderFns } from "./BalanceModalTitle.vue?vue&type=template&id=395d04cc&scoped=true"
import script from "./BalanceModalTitle.vue?vue&type=script&lang=js"
export * from "./BalanceModalTitle.vue?vue&type=script&lang=js"
import style0 from "./BalanceModalTitle.vue?vue&type=style&index=0&id=395d04cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395d04cc",
  null
  
)

export default component.exports